<div class="d-flex flex-column">

    <div class="d-flex flex-wrap mt-1 px-1" *ngIf="allowPredefinedRange">
        <button
            *ngFor="let item of items"
            type="button"
            class="btn btn-outline-secondary btn-sm rounded-pill date-item ms-1 mb-1"
            [ngClass]="{active: isFiltered(item)}"
            [disabled]="!item.count"
            (click)="filterItem(item, $event)">

            {{item | sqValue:item.$column}}

            <span *ngIf="showCount && item.count"
              class="counter rounded-pill bg-light text-black ms-1"
              [title]="item.count + ' occurrences in document'">
              {{item.count}}
            </span>
        </button>
    </div>

    <div class="d-flex py-1" *ngIf="allowCustomRange && allowPredefinedRange">
        <button type="button"
            class="btn no-shadow px-2 py-0"
            [sqTooltip]="showCustomRange ? ('msg#facetCard.collapse' | sqMessage) : ('msg#facetCard.expand' | sqMessage)"
            (click)="toggleCustomRange($event);">
            <i class="text-muted fas fa-chevron-circle-{{showCustomRange ? 'up' : 'down'}}"></i>
            <span class="ms-1 text-muted">{{'msg#facet.date.custom' | sqMessage}} :</span>
        </button>
    </div>


    <sq-collapse [collapsed]="!showCustomRange">
      <ng-template>
        <form [formGroup]="form" *ngIf="allowCustomRange">
            <div class="px-2 py-1 small">
                <sq-date-range-picker
                    [formControlName]="'dateRange'"
                    sqAdvancedFormValidation
                    [size]="'sm'"
                    [field]="'dateRange'"
                    [validationForm]="form"
                    [display]="'column'"
                    [displaySeparator]="false"
                    [displayLabel]="true">
                </sq-date-range-picker>
            </div>
        </form>

        <sq-timeline
            *ngIf="allowCustomRange"
            [data]="timeSeries"
            [selection]="selection"
            width="{{timelineWidth}}"
            height="{{timelineHeight}}"
            [margin]="timelineMargin"
            [showTooltip]="false"
            [curveType]="'curveLinear'"
            (selectionChange)="updateRange($event)"
            (rangeChange)="cdRef.markForCheck()">
        </sq-timeline>

      </ng-template>
    </sq-collapse>

</div>
